import { createReducer, on } from '@ngrx/store';
import {
  loadMaritalStatusFailure,
  loadMaritalStatusSuccess,
  toggleMaritalStatusLoading,
} from './marital-status.actions';
import { initialUIState } from './marital-status.state';

export const maritalStatusReducer = createReducer(
  initialUIState,
  on(toggleMaritalStatusLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),
  on(loadMaritalStatusSuccess, (state, { maritalStatus }) => ({
    ...state,
    list: maritalStatus,
    isLoading: false,
  })),
  on(loadMaritalStatusFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
);
